const hashProductsMarkUp = new Map();
const hashTemplatesMurkUp = new Map();
class VariantSelects extends HTMLElement {
  abortController = undefined;
  swapController = undefined

  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.getVariantData();
    this.updateOptions();
    this.updateMasterId();

    this._onHistoryChange = this.onHistoryChange.bind(this);
    window.addEventListener('popstate', this._onHistoryChange);

    this._onGroupChange = this.onGroupChange.bind(this);
    this.querySelector('product-group-selector')?.addEventListener('change', this._onGroupChange);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this._onHistoryChange);
    this.querySelector('product-group-selector')?.removeEventListener('change', this._onGroupChange);
  }

  connectedCallback() {
    if(hashProductsMarkUp.size === 0){
      const hashUrl = `/products/${this.currentProduct.handle}?variant=${this.currentVariant.id}`
      hashProductsMarkUp.set(hashUrl, this.closest('section').innerHTML)
      hashTemplatesMurkUp.set(hashUrl, this.closest('body').innerHTML)
    }

    if(hashProductsMarkUp.size < 0) return

    const targetProductGroup = this.querySelector(`product-group-selector [data-product-group-id="${this.productsData[0]?.id}"]`)
    targetProductGroup && (targetProductGroup.checked = true);

    this.sendEvents();

    this.updateVariantStatuses();
  }

  sendEvents(){
    try{
      const user_data = window.customer || {
        email: undefined,
        phone_number: undefined,
        address: {
          first_name: undefined,
          last_name: undefined
        }
      }

      const data = [{
        id: `shopify_US_${this.currentProduct}_${this.currentVariant.id}`,
        name: this.currentVariant.name,
        brand: "Cloud Slides",
        category: "",
        price: this.currentVariant.price / 100,
        variant: this.currentVariant.public_title
      }]

      gtag("event", "view_item", {
        send_to: [
          "G-XJ2T5FVWDD",
          "AW-354965863/jDcfCJ2TjM8aEOeyoakB",
          "MC-S2TB4XF6Y2",
          "MC-TT1ZY7PRHQ"
        ],
        developer_id: {dNzYwYj: true},
        ecomm_prodid: [`shopify_US_${this.currentProduct.id}_${this.currentVariant.id}`],
        ecomm_totalvalue: this.currentVariant.price / 100,
        ecomm_pagetype: "product",
        items: data,
        user_data: user_data
      })
      
      
      fbq('track', 'View Content', {
        event_id: new Date().getTime(),
        content_ids: [this.currentVariant.id],
        content_name: this.currentVariant.name,
        content_type: "product",
        currency: window.Shopify.currency.active,
        value: this.currentVariant.price / 100
      });
    }catch (e) {
      console.log(e)
    }
  }

  onGroupChange(event){
    this.groupInputs = this.groupInputs || this.querySelectorAll('[name="product-group"]')

    this.groupInputs.forEach(input => input.toggleAttribute('checked', event.target == input));
    this.updateProductInfo(event.target.getAttribute('data-href'), true);
  }

  onHistoryChange(){
    const params = new URL(window.location.href).searchParams;

    const variantId = params.get('variant')
    const productHandle = window.location.pathname.split('/').at(-1)

    const productExists = this.productsData.find(
      (product) => product.handle === productHandle
    );

    if (!productExists) {
      this.currentVariant = null;
    } else {
      this.currentVariant = variantId && variantId !== 'null'
        ? this.variantData.find(({id}) => id == variantId) : this.variantData[0]
    }


    if(this.currentVariant) {
      this.getVariantRelationship(this.currentVariant.id);
      this.toggleAddButton(true, '', false);

      this.querySelectorAll('fieldset')?.forEach((fieldset, index) => {
        const targetOptionElement = fieldset.querySelector(`input[value="${this.currentVariant.options[index]}"]`)
        targetOptionElement && (targetOptionElement.checked = true);
      })

      this.updateVariantStatuses();
      this.updateMedia();
    }

    this.updateProductInfo(`${window.location.pathname}?variant=${variantId}`, !this.currentVariant)
  }

  onVariantChange(event) {
    if(event.target.getAttribute('form') !== this.dataset.formId) return
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();
    this.updateLabel(event);    

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateTitle();
      this.updateVariantInput();
      this.updateProductInfo();
    }
  }

  updateTitle(){
    this.titleElement = this.titleElement || document.querySelector('.ProductMeta__Title');

    this.titleElement.textContent = this.currentProduct.title
  }

  updateLabel(event) {
    const label = event.target.closest('fieldset')?.querySelector('legend [data-selected-value]');
    label && (label.textContent = event.target.dataset.name)
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll(`[form="${this.dataset.formId}"][type="radio"]:checked`), (input) => input.value);
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }) || this.variantData.find((variant) => {
      return variant.options[0] === this.options[0];
    });

    this.currentProduct = this.getVariantRelationship(this.currentVariant?.id);
  }

  updateMedia() {
    const firstColorVariant = this.variantData.find(({option1}) => option1 === this.currentVariant?.option1);

    const product = this.getVariantRelationship(firstColorVariant?.id)

    if(!product) return

    document.getElementById('MainProduct-MainGallery')?.setActiveMedia(firstColorVariant.featured_media.id, product.id)
  }

  updateURL(url) {
    if (!this.currentVariant && !url) return;

    url = url || `/products/${this.currentProduct.handle}?variant=${this.currentVariant.id}`

    if(this.dataset.historyState === 'update'){
      window.history.replaceState({}, '', url);
    }else{
      window.history.pushState({}, '', url);
    }
  }

  updateVariantInput() {
    const input = document.getElementById(this.dataset.formId)?.querySelector('input[name="id"]');

    if(input) {
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      input.classList.toggle('disabled', !listOfAvailableOptions.includes(input.getAttribute('value')))
    });
  }

  async updateProductInfo(hashUrl, swapTemplate){
    this.abortController?.abort();
    this.abortController = new AbortController();

    const requestedVariantId = this.currentVariant?.id;
    const product = this.currentProduct;
    hashUrl =  hashUrl || `/products/${product?.handle}?variant=${requestedVariantId}`


    if(swapTemplate) return this.swapTemplate(hashUrl);

    const requestUrl = `${hashUrl}&section_id=${this.dataset.section}`

    const responseText = hashProductsMarkUp.get(`${hashUrl}`) ||
      await (await fetch(requestUrl, {signal: this.abortController.signal})).text()

    !hashProductsMarkUp.get(hashUrl) &&
    hashProductsMarkUp.set(hashUrl, responseText);

    this.sendEvents();
    this.renderProductInfo(responseText);
  }

  async swapTemplate(productUrl) {
    this.swapController?.abort();
    this.swapController = new AbortController();

    const swapSections = document.querySelectorAll(".shopify-section--product ~ .shopify-section")
    if(!hashTemplatesMurkUp.get(productUrl))
    swapSections.forEach(section => section.classList.add('loading'))

    const fetchedPage = hashTemplatesMurkUp.get(productUrl) ||
      await (await fetch(productUrl, {
        signal: this.swapController.signal
      })).text()

    if(!hashTemplatesMurkUp.get(productUrl)) hashTemplatesMurkUp.set(productUrl, fetchedPage)


    const parsedPage = new DOMParser().parseFromString(fetchedPage, 'text/html');
    const productGroups = document.querySelector('product-group-selector');
    const fetchedProductGroups = parsedPage.querySelector('product-group-selector')

    productGroups && fetchedProductGroups && (fetchedProductGroups.innerHTML = productGroups.innerHTML);

    const sizeGuidePopup = document.querySelector('size-guide-modal');
    const fetchedSizeGuidePopup = parsedPage.querySelector('size-guide-modal')

    sizeGuidePopup && fetchedSizeGuidePopup && (fetchedSizeGuidePopup.innerHTML = sizeGuidePopup.innerHTML);

    document.querySelector('main')?.replaceWith(parsedPage.querySelector('main'));

    document.dispatchEvent(new CustomEvent('reinit:page'))

    this.updateURL(productUrl)

    // this.runVideo()
  }

  runVideo(){
    document.querySelectorAll('video[muted="muted"][autoplay="autoplay"]').forEach(video => video.play())
  }

  renderProductInfo(responseText) {
    const productWrapper = this.closest('[data-section-type="product"]')

    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = productWrapper.querySelector('[data-price-list]');
    const source = html.querySelector('[data-price-list]');

    if (source && destination) destination.innerHTML = source.innerHTML;

    const addButton = document.getElementById(this.dataset.formId)?.querySelector(`[type="submit"]`);
    const addButtonUpdated = html.getElementById(this.dataset.formId)?.querySelector(`[type="submit"]`);

    addButton.outerHTML = addButtonUpdated.outerHTML

    const fetchedOptions = html.querySelectorAll('fieldset')
    this.querySelectorAll('fieldset').forEach((field, index) => {
      field.innerHTML = fetchedOptions[index].innerHTML
    })

    this.updateVariantStatuses();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(this.dataset.formId);

    if (!productForm) return;
    const addButton = productForm.querySelector('[type="submit"]');
    const addButtonText = addButton.querySelector('span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('data-disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('data-disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const form = document.getElementById(this.dataset.formId);
    const addButton = form.querySelector('[type="submit"]');
    const addButtonText = form.querySelector('[type="submit"] > span');
    const price = form.querySelector('[data-price-list]');

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.productsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    this.variantData = this.productsData.flatMap(product => product.variants);
  }

  getVariantRelationship(variantId) {
    return this.productsData.find(product => product.variants.find(({id}) => id == variantId));
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductGallery extends HTMLElement {
  SLIDER_TYPES = {
    slider: 'slider',
    stacked: 'stacked'
  }

  constructor() {
    super();

    if(this.dataset.observe === "true"){
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.init()
            observer.disconnect()
          }
        });
      });

      observer.observe(this)
    }else {
      this.init();
    }
  }

  init(){
    this.mainGallery = this.querySelector('[data-main-gallery]');
    this.thumbnailsGallery = this.querySelector('[data-thumbnails-gallery]');

    if(!this.mainGallery) return;
    this.initGallery();
    if(this.dataset.type === this.SLIDER_TYPES.slider) this.selectInitial();
    this.loadingImage();
  }

  initGallery(){
    this.mainGallerySlider = new Flickity(this.mainGallery, JSON.parse(this.mainGallery.dataset.sliderConfig));
    this.thumbnailsGallerySlider = new Flickity(this.thumbnailsGallery, JSON.parse(this.thumbnailsGallery.dataset.sliderConfig));
  }


  setActiveMedia(mediaId, productId){    
    if(this.dataset.type === this.SLIDER_TYPES.stacked){
      this.productId = productId
      this.rebuildSlider()

      return
    }

    const activeSlide = this.mainGallery.querySelector(`[data-media-id="${mediaId}"]`)
    const index = this.mainGallerySlider?.cells?.findIndex(slide => slide.element === activeSlide)

    if(index < 0) return;

    this.mainGallerySlider.select(index)
  }

  rebuildSlider(){
    this.destroyGallery();

    [this.mainGallery, this.thumbnailsGallery].forEach(slider => {
      slider.querySelectorAll('.Product__SlideItem, .carousel-cell').forEach(slide => {
        slide.classList.toggle('hidden', this.productId != slide.dataset.productId);
      })
    })

    this.initGallery()
  }

  destroyGallery(){
    [this.mainGallerySlider, this.thumbnailsGallerySlider].forEach((slider) => {
      slider?.destroy()
    })
  }

  selectInitial(){

    const initialSlide = this.mainGallery.querySelector('.is-initial-select')

    if(!initialSlide) return;

    this.setActiveMedia(initialSlide.dataset.mediaId)
  }

  loadingImage(){
    const images = this.querySelectorAll('img[data-src]');

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        observer.unobserve(img);

        img.style.transition = 'opacity 0.3s';
        img.style.opacity = 1;
      });
    }, {
      rootMargin: "100px",
      threshold: 0.1
    });

    images.forEach(img => {
      img.style.opacity = 0;
      observer.observe(img);
    });
  }
}

customElements.define('product-gallery', ProductGallery);

class ProductCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.displayElement = null;
  }

  connectedCallback() {
    this.displayElement = this.querySelector('b');
    if (!this.displayElement) return;

    this.updateTimer();
    this.intervalId = setInterval(() => this.updateTimer(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  updateTimer() {
    const now = Date.now();
    const endTime = this.getEndTime(now);
    const remainingMs = endTime - now;

    if (remainingMs > 0) {
      this.displayElement.textContent = this.formatRemainingTime(remainingMs);
      this.classList.add('is-active');
    } else {
      this.clearStoredEndTime();
      this.classList.remove('is-active');
      clearInterval(this.intervalId);
    }
  }

  getEndTime(now) {
    const attrEndDate = this.getAttribute('data-end-time');
    if (attrEndDate) return new Date(attrEndDate).getTime();

    const storedEndTime = this.getStoredEndTime();
    if (storedEndTime) return storedEndTime;

    const newEndTime = this.generateRandomEndTime(now);
    this.storeEndTime(newEndTime);
    return newEndTime;
  }

  getStoredEndTime() {
    const key = this.getStorageKey();
    const stored = localStorage.getItem(key);
    return stored ? parseInt(stored, 10) : null;
  }

  storeEndTime(endTime) {
    localStorage.setItem(this.getStorageKey(), endTime);
  }

  clearStoredEndTime() {
    localStorage.removeItem(this.getStorageKey());
  }

  getStorageKey() {
    // Використовує унікальний ключ для кожного таймера
    const id = this.getAttribute('data-timer-id') || 'default';
    return `productCountdownEnd_${id}`;
  }

  generateRandomEndTime(now) {
    const minSeconds = 2 * 60 * 60; // 2 години
    const maxSeconds = 6 * 60 * 60; // 6 годин
    const randomSeconds = Math.floor(Math.random() * (maxSeconds - minSeconds) + minSeconds);
    return now + randomSeconds * 1000;
  }

  formatRemainingTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => (n < 10 ? '0' + n : n);
    return (
      (days > 0 ? pad(days) + ':' : '') +
      pad(hours) + ':' +
      pad(minutes) + ':' +
      pad(seconds)
    );
  }
}

customElements.define('product-countdown', ProductCountdownTimer);

class ProductVariantUpsell extends HTMLElement {
  constructor() {
    super();

    this.setupVisibility();

    this.formHandler();

    this.galleries = [...document.querySelectorAll('.Product__GalleryWrapper product-gallery')];
    this.gallery = this.galleries.find(gallery => gallery.id == this.dataset.galleryId)
  }

  formHandler(){
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]')

    this.form.addEventListener('change', event => {
      this.submitButton.removeAttribute('disabled');
      if(event.target.dataset.featuredMediaId) this.gallery.setActiveMedia(event.target.dataset.featuredMediaId)
    })

    this.form.addEventListener('submit', event => {
      event.preventDefault();

      this.submitButton.setAttribute('disabled', 'disabled');

      const formData = new FormData(this.form);

      fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => {

          if (response.ok) {
            this.classList.add('Added');

            this.submitButton.classList.add('Added');
            this.submitButton.querySelector('span').innerHTML = this.submitButton.getAttribute('data-added');

            setTimeout(function() {
              document.dispatchEvent(
                new CustomEvent('upsell:added')
              );
            }, 100);
          }
        });
    })
  }

  setupVisibility(){
    this.querySelector('[data-opener]')?.addEventListener('click', event => {
      this.toggle()
    })

    this.querySelector('[data-overlay-part]')?.addEventListener('click', event => {
      this.close();
    })
  }

  open(){
    this.classList.add('Opened');
    this.lastActiveGallery = this.galleries.find(gallery => !gallery.classList.contains('hidden'));

    this.galleries.forEach(gallery => gallery.classList.add('hidden'));
    this.gallery.classList.remove('hidden');
  }

  close(){
    this.classList.remove('Opened');

    this.galleries.forEach(gallery => gallery.classList.add('hidden'));
    this.lastActiveGallery.classList.remove('hidden');
  }

  toggle(){
    this.classList.contains('Opened') ?
      this.close() : this.open();
  }
}

customElements.define('product-variant-upsell', ProductVariantUpsell);

class SizeGuideModalOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', event => {
      document.querySelector('size-guide-modal.size-guide')?.open();
    })
  }
}

customElements.define('size-guide-modal-opener', SizeGuideModalOpener);


class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.closeButton = null;
    this.onBodyClick = this.onBodyClick.bind(this);

    this.productsData = JSON.parse(this.querySelector('[type="application/json"]')?.innerHTML || '[]')
  }

  connectedCallback() {
    this.closeButton = this.querySelector('.modal__close');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onBodyClick);
  }

  open() {
    this.classList.add('show');
    this.body.classList.add('pop_active');
    document.dispatchEvent(new CustomEvent('modal:open'));
    this.body.addEventListener('click', this.onBodyClick);

    const productId = document.querySelector('variant-selects')?.currentProduct.id
    if(!productId) return

    const sizeChartId = this.productsData.find(item => item.productId == productId)?.sizeChartId
    if(!sizeChartId) return

    document.querySelector(`[data-size-age="${sizeChartId}"]`)?.dispatchEvent(new Event('click'))
  }

  close() {
    this.classList.remove('show');
    this.body.classList.remove('pop_active');
    document.dispatchEvent(new CustomEvent('modal:close'));
    this.body.removeEventListener('click', this.onBodyClick);
  }

  onBodyClick(e) {
    if (e.target === this || e.target.classList.contains('size-guide')) {
      this.close();
    }
  }
}

customElements.define('size-guide-modal', SizeGuideModal);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    const items = document.querySelectorAll('.ProductMeta__TabItem');

    if (!items.length) {
      return;
    }

    items.forEach((item) => {
      const itemHeading = item.querySelector('.ProductMeta__TabItem__Heading');

      itemHeading.addEventListener('click', () => {
        item.classList.toggle('is-active');
      });
    });
  }
}

customElements.define('product-tabs', ProductTabs);